export var AssistanceModalSize;
(function (AssistanceModalSize) {
    AssistanceModalSize["S"] = "600px";
    AssistanceModalSize["M"] = "960px";
})(AssistanceModalSize || (AssistanceModalSize = {}));
//# sourceMappingURL=AssistanceModalSize.js.map